export const GET_TICKETS = "GET_TICKETS"
export const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS"
export const GET_TICKETS_FAIL = "GET_TICKETS_FAIL"

export const GET_TICKET_DETAIL = "GET_TICKET_DETAIL"
export const GET_TICKET_DETAIL_SUCCESS = "GET_TICKET_DETAIL_SUCCESS"
export const GET_TICKET_DETAIL_FAIL = "GET_TICKET_DETAIL_FAIL"

export const CREATE_SUPPORT_TICKET = "CREATE_SUPPORT_TICKET"
export const CREATE_SUPPORT_TICKET_SUCCESS = "CREATE_SUPPORT_TICKET_SUCCESS"
export const CREATE_SUPPORT_TICKET_FAIL = "CREATE_SUPPORT_TICKET_FAIL"

export const REPLY_SUPPORT_TICKET = "REPLY_SUPPORT_TICKET"
export const REPLY_SUPPORT_TICKET_SUCCESS = "REPLY_SUPPORT_TICKET_SUCCESS"
export const REPLY_SUPPORT_TICKET_FAIL = "REPLY_SUPPORT_TICKET_FAIL"
